import Network from 'infrastructure/js/modules/network';

export function fetchCassettes(query = {}) {
  return Network.post('cassettes/items?active=true', query);
}

export function fetchArchivedCassettes(query = {}) {
  return Network.post('cassettes/items?active=false', query);
}

export function updateCassette(spoolId, data) {
  return Network.put(`cassettes/${spoolId}`, data);
}

export function generateCassetteId() {
  return Network.get('cassettes/generateId');
}

export function createCassette(data, locationId) {
  return Network.post('cassettes', data);
}

export function getCassettesDataByStationId(stationID, query = {}) {
  return Network.post(`stations/${stationID}/cassettes/items?active=true`, query);
}

export function getCassetteDetails(assetId){
  return Network.get(`cassettes/${assetId}`);
}

export function updateShelfLife(data, callback) {
  return Network.polling.post('cassettes/multiShelfLifeUpdate' , data, {callback});
}

export function editCassetteAttributes(data, callback){
  return Network.polling.put('cassettes/update' , data, callback);
}

